import App from '../../../assets/js/app';

import { bindEvents } from '../../../assets/js/helpers';

import AnimationController from '../../../assets/js/controller/animation';


const selector = 'cover-chapter';

export default class CoverChapter {

	constructor(section) {
		this.el = {
			section,
			mask: section.querySelector(`.${selector}__mask`),
			background: section.querySelector(`.${selector}__background`),
			hint: section.querySelector(`.${selector}__hint`)
		};

		this.height = 0;

		this.position = 0;
		this.scale = 0;

		this.animation = null;

		this.events = bindEvents(this);

		this.tunneledVideo = App.receiveCoverVideo(this.el.video);
		if (this.tunneledVideo) {
			this.el.video = this.tunneledVideo;
			this.el.section.classList.add('showing-video');
			this.el.section.classList.add('showing-text');
		} else {
			this.el.video = document.createElement('video');
			this.el.video.src = `${this.el.background.dataset.videoSource}-${(window.innerWidth < 1024 ? 50 : 100)}.mp4`;
			this.el.video.muted = true;
			this.el.video.playsinline = true;
			this.el.video.loop = true;
			this.el.video.setAttribute('muted', 'muted');
			this.el.video.setAttribute('playsinline', 'playsinline');
			this.el.video.setAttribute('loop', 'loop');
			this.el.video.addEventListener('play', this.events._onVideoPlay);
		}
		this.el.background.appendChild(this.el.video);
		this.el.video.play();

		this.addEventListeners();

		this.measure();
		this.start();
		this.positionHint();
	}

	static get selector() {
		return selector;
	}

	measure() {
		this.height = this.el.section.offsetHeight;
	}

	positionHint() {
		this.el.hint.style.bottom = `${this.height - window.innerHeight + 40}px`;
	}

	update(position) {
		const max = Math.round(this.height / 2);
		let p = Math.round(position.current / 2);
		if (p > max) p = max;
		if (p !== this.position) {
			this.position = p;
			this.scale = 1 + (p / max * 0.5);
			return true;
		}
	}

	render() {
		this.el.mask.style.transform = `translate3d(0,${this.position}px,0)`;
		this.el.background.style.transform = `scale3d(${this.scale},${this.scale},1)`;
	}

	start() {
		this.animation = AnimationController.set({
			update: this.update.bind(this),
			render: this.render.bind(this)
		}, 'chapter cover');
	}

	pause() {
		AnimationController.clear(this.animation);
	}

	_onWindowLoad() {
		this.measure();
		this.positionHint();
	}

	_onWindowResize() {
		this.measure();
	}

	_onVideoPlay() {
		this.el.section.classList.add('fading-video');
		this.el.section.classList.add('showing-text');
	}

	addEventListeners() {
		window.addEventListener('load', this.events._onWindowLoad);
		window.addEventListener('resize', this.events._onWindowResize);
	}

	removeEventListeners() {
		window.removeEventListener('load', this.events._onWindowLoad);
		window.removeEventListener('resize', this.events._onWindowResize);
	}

	destroy() {
		this.pause();
		this.removeEventListeners();
	}

}
